import { render, staticRenderFns } from "./BankDetailsForm.vue?vue&type=template&id=0d625092&scoped=true"
import script from "./BankDetailsForm.vue?vue&type=script&lang=js"
export * from "./BankDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./BankDetailsForm.vue?vue&type=style&index=0&id=0d625092&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d625092",
  null
  
)

export default component.exports